import Vue from 'vue'
import Vuex from 'vuex'
import * as api from '@/api'
import router from '../router'
import createPersistedState from "vuex-persistedstate";
import LocalForage from 'localforage'
import Cookies from 'js-cookie';
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
LocalForage.config({
  driver      : LocalForage.IndexedDB,
  name        : 'CBTGRAFINDO',
  version     : 1.0,
  storeName   : 'cbt-grafindo'
});

const vuexPersist = new VuexPersistence({
  key: 'soal',
  storage: LocalForage,
  asyncStorage: true,
  reducer: (state) => ({ mapel: state.mapel }),
})

export default new Vuex.Store({
  state: {
    status: '',
    token: null,
    user : {},
    reset_code: '',
    message: '',
    mapel: {},
    forceLogoutData: null,
    snackbar: {
      show: false,
      text: '',
      color: 'success',
      timeout: 3000
    }
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    SET_FORCE_LOGOUT_CONFIRMATION(state, data) {
      state.forceLogoutData = data || {}
      state.status = 'force_logout_required'
    },
    
    CLEAR_FORCE_LOGOUT_CONFIRMATION(state) {
      state.forceLogoutData = null
      state.status = ''
    },
    auth_success(state, data){
      state.status = 'success'
      state.token = data.token
      state.user = data.user
    },
    auth_error(state, message){
      state.status = 'error'
      state.message = message
    },
    logout(state){
      state.status = ''
      state.token = null
      state.user = {}
      state.reset_code = ''
      state.mapel= {}
    },
    updateUser(state, data){
      state.user = data
    },
    updateMapel(state, data){
      state.mapel = data
    },
    removeMapel(state){
      state.mapel = {}
    },
    SHOW_SNACKBAR(state, { text, color, timeout }) {
      state.snackbar = {
        show: true,
        text: text || '',
        color: color || 'success',
        timeout: timeout || 3000
      }
    },
    HIDE_SNACKBAR(state) {
      state.snackbar.show = false
    }
  },
  actions: {
    async login({commit}, user) {
        commit('auth_request')
        
        try {
            await api.post('auth/login', user, (response) => {
                if (response.status && response.data) {
                    if (response.data.status === true) {
                        // ✅ LOGIN SUCCESS
                        commit('auth_success', response.data)
                        localStorage.setItem('token', response.data.token)
                    } else if (response.data.require_confirmation) {
                        // ✅ NEED FORCE LOGIN CONFIRMATION
                        commit('SET_FORCE_LOGOUT_CONFIRMATION', response.data)
                    } else {
                        // ✅ LOGIN FAILED
                        commit('auth_error', response.data.message || 'Login gagal')
                    }
                } else {
                    commit('auth_error', response.message || 'Login gagal')
                }
            })
        } catch (error) {
            commit('auth_error', 'Terjadi kesalahan sistem')
        }
    },
    async forceLogin({commit}, userData) {
        try {
            // Add force_login flag
            const loginData = {
                ...userData,
                force_login: true
            }
            
            await api.post('auth/login', loginData, (response) => {
                if (response.status && response.data && response.data.status === true) {
                    commit('auth_success', response.data)
                    commit('CLEAR_FORCE_LOGOUT_CONFIRMATION')
                    localStorage.setItem('token', response.data.token)
                } else {
                    commit('auth_error', response.data.message || 'Force login gagal')
                }
            })
      } catch (error) {
            commit('auth_error', 'Terjadi kesalahan sistem')
        }
    },

    async logout({commit}){
      if(this.state.token!=null){
        await api.get('auth/logout', {logout: true}, async (res) => {
          if (res.status) {
            commit('logout')
          }
        })
        commit('logout')
        router.push('/login')
      }
    },
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
  },
  plugins: [
    createPersistedState({
      paths: ['token', 'user', 'reset_code'],
      key: 'auth',
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 365, secure: false }),
        removeItem: key => Cookies.remove(key)
      },
    }),
    vuexPersist.plugin
  ]
})